import { AuswahlErfassungsmodus } from './functions/AuswahlErfassungsmodus';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { createStructureForKennziffern, prepareStructureForKennziffern } from './functions/createStructureForKennziffern';
import { CustomDatensatzRfg, hasEntityActivatedRfg, getFormRfgBtns, gibtEMIEJMAED } from './functions/CustomDatensatzRfg';
import { CustomRowName } from './functions/CustomRowName';
import { DataService } from '../../services/data_service';
import { DatenauswertungJahrauswahl } from '../datenauswertung/DatenauswertungJahrauswahl';
import { DateneingabeEnergiedatenKomplexForm } from './DateneingabeEnergiedatenKomplexForm';
import { DateneingabeSachanlagenAuswahl } from './DateneingabeSachanlagenAuswahl';
import { delDataKennziffern, saveDataKennziffern, transformWerteKennziffern } from './functions/dataHandlingForKennziffern';
import { DialogOelBerechnung } from './dialogs/DialogOelBerechnung';
import { DialogStromVerbrauch } from './dialogs/DialogStromVerbrauch';
import { DialogWaermeVerbrauch } from './dialogs/DialogWaermeVerbrauch';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import formStyle from '../../core/forms/style/WForm.less';
// import { getAssistentConfigKraftstoffe } from './assistent/items/assistent_config_kraftstoffe';
import {
    getAutoSaveIntervall, getBtnCalculatorKey, isEnableCO2, isEnableErneuerbareEnergien, isEnableEnergiesteuerrueckerstattung,
    isEnableGHG, isEnableSachanlagen
} from './assistent/assistent_helpers';
import { getCustomFormConfig } from './co2_custom/getCustomFormConfig';
import { getDataYears } from '../datenauswertung/helper/getDataYears';
import { getEnergiedatenAuswahl, getSelectableEnergiedatenEntities } from './functions/getEnergiedatenStructure';
import { getFormKey } from '../../main/functions/getFormKey';
import { getGewerk } from '../../main/functions/getGewerk';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings, findStandorteTabRouting } from './functions/StandorteGruppen';
import { getValidDataEntitiesMap } from '../../main/functions/getValidDataEntitiesMap';
// import { getVeranstaltungen } from '../../helpers/getVeranstaltungen';
import { hasEnergietraegerRechner } from './functions/hasEnergietraegerRechner';
import { hideKomplexRows, recordHiddenRows } from '../../main/functions/hideKomplexRows';
import { IDs } from '../../helpers/IDs';
import { ImportButtonWrapper } from './assistent/items/wrapper/ImportButtonWrapper';
import { KennzahlenButtonWrapper } from './assistent/items/wrapper/KennzahlenButtonWrapper';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import { processKennziffernBerechnung } from '../../main/functions/processKennzahlenBerechnng';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { sortKomplexDataRows } from '../../main/functions/sortKomplexDataRows';
import { StandorteEigenstromTabs } from './detail/eigenstrom/StandortEigenstromTabs';
// import { StructureService } from '../../services/structure_service';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { TriggerService } from '../../core/trigger/trigger_service';
import { Validierung } from '../datenauswertung/elements/Validierung';
import { ValidierungHinweise } from '../datenauswertung/elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormConfig } from '../../core/forms/WFormFramework';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

interface DateneingabeEnergiedatenKomplexProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
    scrollLeft: number;
    style?: React.CSSProperties;
    getScrollTop?: () => number;
    setScrollTop?: (scrollTop: number) => void;
}

interface DateneingabeEnergiedatenKomplexState {
    konfig: any;
    jahr_von: number;
    jahr_bis: number;
    jahr_min: number;
    jahr_max: number;
    entities: any;
    validData: any;
    loadingDone: boolean;
    onFormRendering: boolean;
    doRenderForm: any;
    extraForms: any;
    showDialog: string;
    showBereiche: any;
    dataForOptionalDialog: any;
    dataForOptionalDialog2: any;
    eigenstrom_typen_s: Array<any>;
    eigenwaerme_typen_w: Array<any>;
    currentYear: number;
    presetFormConfig: any;
    forceNoRenderOnce: boolean;
    validation: any;
    mouseOverHinweise: number;
    erfassungsmodus: string;
    activeFormKey: string;
    jahrForEnergiedatenAuswahl: number;
}

export class DateneingabeEnergiedatenKomplex extends
    React.Component<DateneingabeEnergiedatenKomplexProps, DateneingabeEnergiedatenKomplexState> {

    constructor(props: any) {
        super(props);
        const jahr_max = Moment().year();
        let konfig;
        let jahr_min = 2015;
        // let jahr_min = 2010;
        let jahr_von;
        let jahr_bis;

        if (Array.isArray(props.data[IDs.ENT_KONFIGURATION]) && props.data[IDs.ENT_KONFIGURATION].length > 0) {
            konfig = props.data[IDs.ENT_KONFIGURATION][0];
            const startjahr: number = (konfig || {}).startjahr_datenerfassung || null;
            jahr_min = (props.data.first_year > 2009 && props.data.first_year < jahr_min) ? props.data.first_year : jahr_min;
            jahr_min = (startjahr > jahr_min) ? startjahr : jahr_min;
            // console.log('Konfig in Komplex: ', konfig);
            // if (konfig.startjahr_datenerfassung && +konfig.startjahr_datenerfassung > 1900) {
            //     jahr_min = konfig.startjahr_datenerfassung;
            // }

            if (konfig.dateneingabe_form_jahr_von && +konfig.dateneingabe_form_jahr_von > 1900) {
                jahr_von = konfig.dateneingabe_form_jahr_von;
            } else {
                jahr_von = (jahr_max - 1) - this.yearRangeStart + 1;
            }

            if (konfig.dateneingabe_form_jahr_bis && +konfig.dateneingabe_form_jahr_bis > 1900) {
                jahr_bis = konfig.dateneingabe_form_jahr_bis;
            } else {
                jahr_bis = (jahr_max - 1);
            }

            // WKETOOL-93 - 447: Geführter Modus / Startjahr: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
            // if (jahr_von < jahr_min) {
            //     jahr_von = jahr_min;
            // }
            if (jahr_von < 2010) {
                jahr_von = 2010;
            }

            // console.log('Jahre', jahr_von, jahr_bis, konfig);
        }
        this.state = {
            konfig,
            jahr_von,
            jahr_bis,
            jahr_min,
            jahr_max,
            entities: undefined,
            validData: {},
            loadingDone: false,
            onFormRendering: false,
            doRenderForm: {},
            extraForms: {},
            showDialog: undefined,
            dataForOptionalDialog: undefined,
            dataForOptionalDialog2: undefined,
            showBereiche: this.contextService.get('energieDatenKomplexBereiche') || { 'energiedaten_strom': true },
            eigenstrom_typen_s: [],
            eigenwaerme_typen_w: [],
            currentYear: undefined,
            presetFormConfig: {},
            forceNoRenderOnce: false,
            validation: {},
            mouseOverHinweise: undefined,
            erfassungsmodus: null,
            activeFormKey: null,
            jahrForEnergiedatenAuswahl: null
        };
        this.delFormData = this.delFormData.bind(this);
        this.forceRerenderForm = this.forceRerenderForm.bind(this);
        this.getFormFunktionBtn = this.getFormFunktionBtn.bind(this);
        this.getFormRechnerBtn = this.getFormRechnerBtn.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onEigenstromTypenChange = this.onEigenstromTypenChange.bind(this);
        this.onValidate = this.onValidate.bind(this);
        this.prepareKennziffernStructure = this.prepareKennziffernStructure.bind(this);
        this.reloadBundle = this.reloadBundle.bind(this);
        this.reloadDataMonat = this.reloadDataMonat.bind(this);
        this.reloadRerenderForm = this.reloadRerenderForm.bind(this);
        this.renderBtnDetailierteErfassung = this.renderBtnDetailierteErfassung.bind(this);
        this.saveForms = this.saveForms.bind(this);
        this.saveJahre = this.saveJahre.bind(this);
        this.setJahrBis = this.setJahrBis.bind(this);
        this.setJahrVon = this.setJahrVon.bind(this);

        this.selectableEnergiedatenEntities = getSelectableEnergiedatenEntities();

        // const urlParams = new URLSearchParams(window.location.search);
        // this.enableFormShowMode = urlParams.get('enableFormShowMode') == '1' || urlParams.get('enableFormShowMode') == 'true';
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    // @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private enableFormShowMode = true;
    private baseWidth = 220;
    private labelWidthExt = 50;
    private yearRangeStart = 1;
    private yearRange = 6;
    private dataTemp: any = {};
    private lastCheckKey: string = undefined;
    private standortTids: number[] = [];
    private saveHandleId: number;
    private savedEntities: any = {};
    private btnCalculator: any = {};
    private currentFormTarget: any;
    private selectableEnergiedatenEntities: Array<string>;
    private lastEnergiedatenAuswahl: Array<string>;

    componentDidMount(): void {
        this.checkBereichePreset();
        this.initValidierung();
        // Typen Eigenstrom und Eigenwärme vorbelegen
        this.onEigenstromTypenChange();
        // Kennziffern-Definition holen
        this.prepareKennziffernStructure();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const energiedatenAuswahl = getEnergiedatenAuswahl(this.props.data, this.props.standortSelected.tid, null, this.state.jahr_von, this.state.jahr_bis);
        if (JSON.stringify(this.lastEnergiedatenAuswahl) !== JSON.stringify(energiedatenAuswahl)) {
            this.lastEnergiedatenAuswahl = energiedatenAuswahl;
            this.initEntities();
        }
        if (JSON.stringify(prevProps.routing) !== JSON.stringify(this.props.routing)) {
            this.checkBereichePreset();
        }
        if ((this.props.standortSelected || {}).tid !== (prevProps.standortSelected || {}).tid) {
            this.initValidierung();
        }

        // WKETOOL-213: Zeilen ohne Eingabefelder in der Tapete ausblenden
        if (this.state.loadingDone) {
            hideKomplexRows(`Komplex_${this.props.standortSelected.tid}`);
        }
    }

    componentWillUnmount() {
        // Es kann sein, dass noch eine Funktion in setTimeout wartet.
        if (this.saveHandleId) {
            this.saveForms();
        }
        // console.log('componentWillUnmount -> Reload', this.savedEntities);
        Object.keys(this.savedEntities).forEach((ent: string) => this.triggerService.fire('reload', ent));
    }

    checkBereichePreset() {
        const routing: any = this.props.routing || {};
        if (routing.entities && Array.isArray(routing.entities)) {
            const bereiche: any = {};
            routing.entities.forEach((entity: string) => bereiche[entity] = true);
            if (JSON.stringify(this.state.showBereiche) !== JSON.stringify(bereiche)) {
                this.contextService.set('energieDatenKomplexBereiche', bereiche);
                this.setState({ showBereiche: bereiche });
            }
        }
    }

    initEntities() {
        const data: any = this.props.data || {};
        const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];
        const modul: string = data.MODUL_SELECTED || null;

        // Jetzt die Entities sowie den Zeitraum setzen (später ggf. anders)
        let entities: any[] = [];
        if (modul === 'steuer') {
            entities.push({
                titel: 'Strom', entity: IDs.ENT_ENERGIEDATEN_STROM,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM
            });
            if (isEnableEnergiesteuerrueckerstattung(konfiguration)) {
                entities.push({
                    titel: 'Wärme/Brennstoffe', entity: IDs.ENT_ENERGIEDATEN_WAERME,
                    route: RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME
                });
            }
        } else {
            const enableErneuerbareEnergien: boolean = isEnableErneuerbareEnergien(konfiguration);
            const enableSachanlagen: boolean = isEnableSachanlagen(konfiguration);
            const enableGHG: boolean = isEnableGHG(konfiguration);
            this.standortTids = (getStandorte(data) || []).map((standort: any) => standort.tid);

            const eigentstrom_button = (
                <button
                    style={{ cursor: 'pointer', border: '1px solid', width: 'min-content' }}
                    onClick={() => this.setState({ showDialog: 'eigenstrom' })}
                >
                    Auswahl
                </button>
            );

            const kennziffern_button = <KennzahlenButtonWrapper
                onChange={() => this.prepareKennziffernStructure(true)}
                data={data}
                forKomplexForm={true}
            />;

            entities.push({
                titel: 'Strom', entity: IDs.ENT_ENERGIEDATEN_STROM,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM
            });
            if (enableErneuerbareEnergien) {
                entities.push({
                    titel: 'Eigenstrom', entity: IDs.ENT_ENERGIEDATEN_EIGENSTROM, headerElement: eigentstrom_button,
                    route: RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM
                });
            }
            entities.push({
                titel: 'Wärme/Brennstoffe', entity: IDs.ENT_ENERGIEDATEN_WAERME,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME
            });
            // Eigenwärme NICHT EINKOMMENTIEREN, soll ausgeblendet bleiben
            // entities.push({
            //     titel: 'Eigenwärme', entity: IDs.ENT_ENERGIEDATEN_EIGENWAERME, headerElement: eigentstrom_button,
            //     route: RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME
            // });
            entities.push({
                titel: 'Kraftstoffe', entity: IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE
            });
            if (modul !== 'cfm') {
                entities.push({
                    titel: 'Wasser/Abwasser', entity: IDs.ENT_ENERGIEDATEN_WASSER,
                    route: RoutingIDs.ROUTE_DATENAUSWERTUNG_WASSER
                });
            }
            entities.push({
                titel: 'Technische Gase/Kältemittel', entity: IDs.ENT_KLIMAGASE,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS
            });
            entities.push({
                titel: 'Kennzahlen', entity: IDs.ENT_KENNZIFFERN_GENERATED, headerElement: kennziffern_button,
                route: RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ
            });
            entities.push({
                titel: modul === 'cfm' ? 'Betriebswirtschaftliche Daten' : 'BWL-Daten', entity: IDs.ENT_BETRIEBSDATEN,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN
            });

            if (enableSachanlagen && enableGHG) {
                entities.push({
                    titel: 'Angemietete Räumlichkeiten', entity: IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN
                });
                entities.push({
                    titel: 'Eigene Räumlichkeiten', entity: IDs.ENT_EIGENE_RAEUMLICHKEITEN
                });
                entities.push({
                    titel: 'Angemietete Fahrzeuge', entity: IDs.ENT_ANGEMIETETE_FAHRZEUGE
                });
            }
            entities.push({
                titel: 'Erfasser:in', entity: IDs.ENT_SONSTIGE_DATEN,
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN
            });
            const energiedatenAuswahl = getEnergiedatenAuswahl(this.props.data, this.props.standortSelected.tid, null, this.state.jahr_von, this.state.jahr_bis);
            entities = entities.filter((e: any) => !(this.selectableEnergiedatenEntities.indexOf(e.entity) !== -1 && energiedatenAuswahl.indexOf(e.entity) === -1));
        }

        // Jetzt die Entities wg. den Bundles laden
        const validData: any = this.getValidDataEntitiesMap();
        const load_goal = entities.length;
        let load_cnt = 0;
        entities.forEach((entity: any) => {
            const processCallback = (result: any) => {
                if (result) {
                    entity.bundle = result?.bundle || {};
                }
                if (entity.entity === IDs.ENT_KLIMAGASE) {
                    entity.bundle.art_tid = this.props.data[IDs.ENT_KLIMAGASE_ART];
                }
                load_cnt++;
                if (load_goal === load_cnt) {
                    this.setState({ loadingDone: true, entities, validData });
                }
            };
            // virtuelle Entities nicht aus dem Backend laden
            if ([IDs.ENT_KENNZIFFERN_GENERATED].indexOf(entity.entity) !== -1) {
                processCallback({});
            } else {
                this.dataService.loadDataForModul(entity.entity, { tid: -1 }, { bundle: true }, IDs.MOD_ETOOL, (result: any) => {
                    processCallback(result);
                });
            }
        });
        return entities;
    }

    initValidierung() {
        const standortTid: number = this.props.standortSelected.tid || null;
        const entities: Array<any> = this.initEntities();
        const validation = new Validierung(this.props.data, standortTid, entities, 'jahr').getData();
        // console.log(validation);
        this.setState({ validation });
    }

    findFotoFields() {
        // ZU TESTEN
        const struct_tool = new StructureTool(IDs.MOD_ETOOL, this.props.data);
        const strucAll = struct_tool.getStructureAllByModul(IDs.MOD_ETOOL);
        if (strucAll) {
            const fnd: any = {};
            Object.keys(strucAll).forEach((ent: string) => {
                if (Array.isArray(strucAll[ent].ATTS)) {
                    const fields = strucAll[ent].ATTS.filter((a: any) => a.TYPE === 'FILE');
                    if (fields.length > 0) {
                        fnd[ent] = fields;
                    }
                }
            });
            // console.log(fnd);
            // console.log(JSON.stringify(fnd));
        }
    }

    forceRerenderForm(key: string) {
        // key ist entityName oder formKey
        const { doRenderForm } = this.state;
        doRenderForm[key] = false;
        this.setState({ doRenderForm }, () => {
            doRenderForm[key] = true;
            this.setState({ doRenderForm }, () => {
                setTimeout(() => this.setFocusOnInput(), 0);
            });
        });
    }

    getMaxRowCnt(dataRows: any, jahr_von: number, jahr_bis: number) {
        const map: any = {};
        for (let j = jahr_von; j <= jahr_bis; j++) {
            if (!map[j]) {
                map[j] = 0;
            }
        }
        dataRows.forEach((r: any) => {
            if (typeof r.jahr === 'number' && r.jahr > 0 && typeof map[r.jahr] === 'number') {
                // Nach dem 1. Round haben DS "_formKey"
                if (!r._formKey || r._formKey.endsWith('_X') /* DS nicht aus extra Zeilen */) {
                    map[r.jahr]++;
                }
            }
        });
        // console.log(map);
        return Math.max(1, ...Object.keys(map).map((j: string) => map[j]));
    }

    getValidDataEntitiesMap(): any {
        return {
            ...getValidDataEntitiesMap(this.props.data, (this.props.standortSelected || {}).tid),
            [IDs.ENT_KLIMAGASE]: true
        };
    }

    getFormRechnerBtn(isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any,
        setValues: (values: any) => void, disabled?: boolean, id?: number, showMode?: boolean, styleProps?: React.CSSProperties) {
        const label = 'Rechner';
        let key = 'monatsverbraeuche';
        let headerLabel = 'Monatsverbräuche';
        let onAction;
        let showBtn;
        let btnOnly = false;
        let insideText = label;
        let btnDisabled = disabled;

        if (entity.entity === IDs.ENT_ENERGIEDATEN_STROM) {
            showBtn = values.abrechnungsmodus === 2; // {2} Monatsrechnungen
            onAction = () => {
                const dataForOptionalDialog = { standortSelected, entity, jahr, values };
                this.setState({ dataForOptionalDialog });
            };
        } else if (entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
            if (id === 1) {
                // den extraElement2-Button ausblenden
                return null;
            }
            // WKETOOL-160: Die Schaltfläche "Monatsverbräuche" wird weiter oben angezeigt
            const energietraeger_tid = typeof values.energietraeger_tid_orig === 'number' ? values.energietraeger_tid_orig : values.energietraeger_tid;
            if (hasEnergietraegerRechner({ energietraeger_tid })) {
                showBtn = true;
                btnDisabled = disabled || !values.energietraeger_tid;
                onAction = () => {
                    if (btnDisabled) {
                        // alert('Bitte wählen Sie zunächst Energieträger aus.');
                    } else {
                        const dataForOptionalDialog2 = {
                            standortSelected, entity, jahr, values, setValues,
                            einheit_tid_orig: values.einheit_tid_orig,
                            energietraeger_tid_orig: values.energietraeger_tid_orig
                        };
                        this.setState({ dataForOptionalDialog2 });
                    }
                };
            } else {
                showBtn = values.abrechnungsmodus === 2; // {2} Monatsrechnungen
                btnDisabled = disabled || !values.energietraeger_tid || !values.einheit_tid;
                onAction = () => {
                    if (btnDisabled) {
                        // alert('Bitte wählen Sie zunächst Monatsrechnungen, Energieträger, und Einheit aus.');
                    } else {
                        const dataForOptionalDialog = { standortSelected, entity, jahr, values };
                        this.setState({ dataForOptionalDialog });
                    }
                };
            }
        } else {
            return null;
        }

        const helpIcon: JSX.Element = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ marginRight: 10 }}
            styleProps={{ margin: 0 }}
            label={`Info "${headerLabel}"`}
            helpKey={`${IDs.MOD_ETOOL}_${entity.entity}_${key}`}
            type='theme_info'
            style='theme_small'
            editBar
            useTheme
        />;

        if (key) {
            const elemBtn = <WActionButton
                styleProps={{
                    height: 20, width: '100%',
                    ...(styleProps || {}),
                    ...(btnDisabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {})
                }}
                label={label}
                tooltip={label}
                insideText={insideText}
                key={key}
                action='calculator'
                onAction={onAction}
                disabled={btnDisabled}
                ref={(button: any) => {
                    if (button !== null) {
                        const btnKey = getBtnCalculatorKey(entity.entity, jahr, values, id || 0);
                        this.btnCalculator[btnKey] = button;
                    }
                }}
            />;
            if (showMode) {
                return <div className={formStyle.fieldBox}>
                    {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
                    <div className={formStyle.input}></div>
                </div>;
            }
            if (btnOnly) {
                return <div>{elemBtn}</div>;
            }
            return <div className={formStyle.fieldBox}>
                {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
                <div className={formStyle.input}>
                    {showBtn && <div style={{ marginTop: -2, marginLeft: -2, marginRight: 2 }}>{elemBtn}</div>}
                </div>
            </div>;
        }

        return null;
    }

    getFormFunktionBtn(isFirst: boolean, entity: any, values: any, showMode?: boolean) {
        const headerLabel = 'Funktionen';
        const label = 'Datensatz löschen';
        const label2 = 'Datensatz entleeren';
        const btnKey = (values._formKey ? values._formKey : 'form') + '_btn_delete';
        const btnKey2 = (values._formKey ? values._formKey : 'form') + '_btn_empty';
        const showDelBtn = values.tid > 0 ? true : false;
        const helpIcon: JSX.Element = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ marginRight: 10 }}
            styleProps={{ margin: 0 }}
            label={`Info "${headerLabel}"`}
            helpKey={`${IDs.MOD_ETOOL}_dateneingabe_funktionen`}
            type='theme_info'
            style='theme_small'
            editBar
            useTheme
        />;

        if (!this.state.loadingDone || showMode || this.saveHandleId) {
            const showInfo = this.saveHandleId && !showMode ? <div style={{ fontStyle: 'italic', marginTop: 3 }}>Datensatz wird gespeichert.</div> : '';
            return <div className={formStyle.fieldBox}>
                {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
                <div className={formStyle.input}>{showInfo}</div>
            </div>;
        }

        // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
        const enableRfg = true;
        const hasActivatedRfg = hasEntityActivatedRfg(entity.entity, this.props.data);
        const isEMIEJMAED = gibtEMIEJMAED(this.props.data[entity.entity] || [], values.jahr, values.jahr, this.props.standortSelected.tid);
        const showEmptyBtn = enableRfg && hasActivatedRfg && isEMIEJMAED && values.tid > 0;
        const entName = entity.entity;
        const onRfgChange = (dataItem1: any, dataItem2: any) => {
            // console.log(dataItem1, dataItem2);
            const items = [{ tid: dataItem1.tid, rfg: dataItem1.rfg }, { tid: dataItem2.tid, rfg: dataItem2.rfg }];
            this.setState({ loadingDone: false }, () => {
                this.dataService.saveDataList(entName, items, (sqlSuc: string, suc: boolean) => {
                    this.setState({ loadingDone: true });
                    if (suc) {
                        console.log('rerender', 'onRfgChange', entName);
                        this.forceRerenderForm(entName);
                    }
                }, IDs.MOD_ETOOL);
            });
        };

        return <div className={formStyle.fieldBox}>
            {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
            <div className={formStyle.input} style={{ display: 'flex' }}>
                {showEmptyBtn && <div style={{ flex: 1 }}>
                    {getFormRfgBtns(entName, values, this.props.data, onRfgChange)}
                </div>}
                {showEmptyBtn && <div style={{ flex: 1 }}>
                    <WActionButton
                        styleProps={{ height: 20, margin: 0, width: 'calc(100% - 8px)' }}
                        label={label2}
                        // insideText={label2}
                        tooltip={label2}
                        key={btnKey2}
                        action='delete'
                        onAction={() => {
                            if (window.confirm('Datensatz wirklich entleeren?')) {
                                this.emptyFormData(entity, values);
                            }
                        }}
                    />
                </div>}
                {showDelBtn && <div style={{ flex: 1 }}>
                    <WActionButton
                        styleProps={{ height: 20, margin: 0, width: 'calc(100% - 8px)' }}
                        label={label}
                        insideText={showEmptyBtn ? null : label}
                        tooltip={label}
                        key={btnKey}
                        action='delete2'
                        onAction={() => {
                            if (window.confirm('Datensatz wirklich löschen?')) {
                                this.delFormData(entity, values);
                            }
                        }}
                    />
                </div>}
            </div>
        </div>;
    }

    onDeleteDone(entName: string, consoleInfo?: string) {
        // 1. postProcess
        processKennziffernBerechnung(this.props.data);
        const validData: any = this.getValidDataEntitiesMap();
        if (JSON.stringify(validData) !== JSON.stringify(this.state.validData)) {
            this.setState({ validData });
        }
        // 2. forceRerenderForm
        console.log('rerender', consoleInfo, entName);
        this.forceRerenderForm(entName);
    }

    emptyFormData(entity: any, row: any) {
        if (row.tid > 0) {
            const { data } = this.props;
            const entName = entity.entity;
            // Datensatz entleeren
            const rowIdx = data[entName].findIndex((r: any) => r.tid === row.tid);
            const emptyData = { ...row };
            const reservedFields: Array<string> = ['tid', 'rfg', '_formKey', 'standort_tid', 'standort_tid_orig', 'jahr', 'abrechnungszeitraum_von', 'abrechnungszeitraum_bis'];
            Object.keys(emptyData).forEach((k: string) => {
                if (reservedFields.indexOf(k) === -1) {
                    emptyData[k] = null;
                }
            });
            data[entName][rowIdx] = emptyData;
            this.dataService.saveData(entName, emptyData, null, null, (suc: boolean) => {
                if (suc) {
                    this.savedEntities[entName] = true;
                    const childRows = data[entName].filter((r: any) => r.parent_tid === row.tid);
                    let cnt = childRows.length;
                    const emptyDone = () => {
                        this.onDeleteDone(entName, 'emptyFormData');
                    };
                    if (cnt > 0) {
                        childRows.forEach((f: any) => {
                            this.dataService.delData(entName, IDs.MOD_ETOOL, { tid: f.tid }, {}, () => {
                                cnt--;
                                if (cnt === 0) {
                                    emptyDone();
                                }
                            });
                        });
                    } else {
                        emptyDone();
                    }
                }
            }, IDs.MOD_ETOOL);
        }
    }

    delFormData(entity: any, row: any) {
        const { data } = this.props;
        const entName = entity.entity;
        if (entName === IDs.ENT_KENNZIFFERN_GENERATED) {
            delDataKennziffern(row, this.props.data, this.dataService, this.triggerService, () => {
                this.savedEntities[entName] = true;
                this.onDeleteDone(entName, 'delFormData');
            });
            return;
        }
        const fndRows = data[entName].filter((r: any) => r.tid === row.tid || (r.parent_tid > 0 && r.parent_tid === row.tid));
        let cnt = fndRows.length;
        if (cnt > 0) {
            this.savedEntities[entName] = true;
            fndRows.forEach((f: any) => {
                this.dataService.delData(entName, IDs.MOD_ETOOL, { tid: f.tid }, {}, () => {
                    const idx = data[entName].findIndex((r: any) => r.tid === f.tid);
                    const validation: any = this.state.validation || {};
                    if (Object.keys(((validation[f.jahr || null] || {})[entName] || {})[f.tid] || {}).length) {
                        delete validation[f.jahr][entName][f.tid];
                        this.setState({ validation });
                    }
                    if (idx >= 0) {
                        data[entName].splice(idx, 1);
                    }
                    cnt--;
                    if (cnt === 0) {
                        // Der alte _formKey kann nun einen falschen Datensatz verweisen.
                        // Hier werden _formKey von dem ganzen Entity gelöscht, damit sie bei renderFormRows() erneuert generiert werden.
                        data[entName].forEach((r: any) => delete r._formKey);
                        this.onDeleteDone(entName, 'delFormData');
                    }
                });
            });
        }
    }

    onChange(entityName: string, data: any, callback?: () => void, timeout?: number, field?: any) {
        // console.log('onChange', entityName, data, timeout);
        if (!this.dataTemp[entityName]) {
            this.dataTemp[entityName] = {};
        }
        if (entityName === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && !data.popup_shown) {
            if (!data.tid || data.tid === 0) {
                if (data.energietraeger_tid_orig === 7 || data.energietraeger_tid === 7) { /* {7} Ladestrom [kWh] */
                    data.popup_shown = true;
                    this.showKraftstoffeEnergietraegerLadestromMessage();
                }
            } else {
                const arr = this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE];
                const found = arr.find((item: any) => item.tid === data.tid);
                if (found) {
                    if (
                        (data.energietraeger_tid_orig === 7 || data.energietraeger_tid === 7) &&
                        (!found.energietraeger_tid_orig || found.energietraeger_tid_orig !== 7 || !data.energietraeger_tid_orig)
                    ) { /* {7} Ladestrom [kWh] */
                        this.showKraftstoffeEnergietraegerLadestromMessage();
                        data.popup_shown = true;
                        data.energietraeger_tid_orig = 7;
                    } else if (data.energietraeger_tid === 7 && !found.energietraeger_tid) {
                        this.showKraftstoffeEnergietraegerLadestromMessage();
                        data.popup_shown = true;
                        data.energietraeger_tid_orig = 7;
                    }
                }
                if (data.energietraeger_tid_name !== 'Ladestrom [kWh]' || data.energietraeger_tid !== 7) {
                    data.energietraeger_tid_orig = '';
                }
            }
        }
        if (entityName === IDs.ENT_ENERGIEDATEN_WAERME && !data.popup_shown) {
            const energietraeger_tid = typeof data.energietraeger_tid_orig === 'number' ? data.energietraeger_tid_orig : data.energietraeger_tid;
            const hasER = hasEnergietraegerRechner({ energietraeger_tid });
            const btnKey = getBtnCalculatorKey(entityName, data.jahr, data);
            if (!data.tid || data.tid === 0) {
                if (data.waerme_dritte_orig === 1 || data.waerme_dritte === 1) {
                    data.popup_shown = true;
                    this.showWaermeDritteMessage();
                }
                if (data.energietraeger_tid_orig === 11 || data.energietraeger_tid === 11) { /* {11} Strom */
                    data.popup_shown = true;
                    this.showWaermeEnergietraegerStromMessage();
                }
                if (data.abrechnungsmodus === 2 || data.abrechnungsmodus_orig === 2) {
                    alert('Bitte wählen Sie zunächst Energieträger und Einheit aus.');
                }
                if (hasER) {
                    // WKETOOL-69 385: Der Brennstoff-Rechner darf zukünftig nicht mehr automatisch Öffnen.
                    // if (this.btnCalculator[btnKey]) {
                    //     this.btnCalculator[btnKey].props.onAction('noWarning');
                    // }
                }
            } else {
                const arr = this.props.data[IDs.ENT_ENERGIEDATEN_WAERME];
                const found = arr.find((item: any) => item.tid === data.tid);
                if (found) {
                    // console.log('W3f:', data, found);
                    if ((data.waerme_dritte_orig === 1 || data.waerme_dritte === 1) &&
                        (!found.waerme_dritte_orig || found.waerme_dritte_orig !== 1 || !data.waerme_dritte_orig)) {
                        data.popup_shown = true;
                        this.showWaermeDritteMessage();
                        data.waerme_dritte_orig = 1;
                    } else if (data.waerme_dritte === 1 && !found.waerme_dritte) {
                        this.showWaermeDritteMessage();
                        data.popup_shown = true;
                        data.waerme_dritte_orig = 1;
                    }
                    if (
                        (data.energietraeger_tid_orig === 11 || data.energietraeger_tid === 11) &&
                        (!found.energietraeger_tid_orig || found.energietraeger_tid_orig !== 11 || !data.energietraeger_tid_orig)
                    ) { /* {11} Strom */
                        this.showWaermeEnergietraegerStromMessage();
                        data.popup_shown = true;
                        data.energietraeger_tid_orig = 11;
                    } else if (data.energietraeger_tid === 11 && !found.energietraeger_tid) {
                        this.showWaermeEnergietraegerStromMessage();
                        data.popup_shown = true;
                        data.energietraeger_tid_orig = 11;
                    }
                    if (+data.energietraeger_tid > 0 &&
                        (
                            (!hasER && +data.abrechnungsmodus === 2 && (+found.abrechnungsmodus !== 2 || +data.energietraeger_tid !== found.energietraeger_tid_orig))
                            || (hasER && +data.energietraeger_tid !== found.energietraeger_tid_orig)
                        )
                    ) {
                        // WKETOOL-69 385: Der Brennstoff-Rechner darf zukünftig nicht mehr automatisch Öffnen.
                        // if (this.btnCalculator[btnKey]) {
                        //     this.btnCalculator[btnKey].props.onAction('noWarning');
                        // }
                    }
                }
                if (data.waerme_dritte_name === 'Nein' || data.waerme_dritte === 2) {
                    data.waerme_dritte_orig = '';
                }
                if (data.energietraeger_tid_name !== 'Strom' || data.energietraeger_tid !== 11) {
                    // Wieso? Die Zeile führt zu Fehler bei setFormConfig(). Kommentiere aus. - 22.08.2023 YW
                    // data.energietraeger_tid_orig = '';
                }
            }
            // SQL-Fehler beim Produktsystem "Data truncated for column 'co2_emissionen'"
            // Wenn co2_emissionen_orig existiert, entfernen wir data.co2_emissionen
            if (data.hasOwnProperty('co2_emissionen_orig')) {
                delete (data.co2_emissionen);
            }
        }
        if (entityName === IDs.ENT_ENERGIEDATEN_STROM && !data.popup_shown) {
            const btnKey = getBtnCalculatorKey(entityName, data.jahr, data);
            if (!data.tid || data.tid === 0) {
                console.log('DATE-LADESTROM NEU', data);
                if (data.strom_dritte_orig === 1 || data.strom_dritte === 1) {
                    data.popup_shown = true;
                    this.showStromDritteMessage();
                }
                if (data.seperate_abrechnung_emobil_strom_orig === 1 || data.seperate_abrechnung_emobil_strom === 1) {
                    data.popup_shown = true;
                    this.showLadestromMessage();
                }
                if (+data.abrechnungsmodus === 2) {
                    // WKETOOL-69 385: Der Brennstoff-Rechner darf zukünftig nicht mehr automatisch Öffnen.
                    if (this.btnCalculator[btnKey]) {
                        this.btnCalculator[btnKey].props.onAction();
                    }
                }
            } else {
                const arr = this.props.data[IDs.ENT_ENERGIEDATEN_STROM];
                const found = arr.find((item: any) => item.tid === data.tid);
                // console.log('DATE-LADESTROM OLD', data, found);
                if (found) {
                    // console.log('W3f:', data, found);
                    if ((data.strom_dritte_orig === 1 || data.strom_dritte === 1) &&
                        (!found.strom_dritte_orig || found.strom_dritte_orig !== 1 || !data.strom_dritte_orig)) {
                        data.popup_shown = true;
                        this.showStromDritteMessage();
                        data.strom_dritte_orig = 1;
                    } else if (data.strom_dritte === 1 && !found.strom_dritte) {
                        this.showStromDritteMessage();
                        data.popup_shown = true;
                        data.strom_dritte_orig = 1;
                    }
                    if ((data.seperate_abrechnung_emobil_strom_orig === 1 || data.seperate_abrechnung_emobil_strom === 1) &&
                        (!found.seperate_abrechnung_emobil_strom_orig || found.seperate_abrechnung_emobil_strom_orig !== 1 ||
                            !data.seperate_abrechnung_emobil_strom_orig)) {
                        data.popup_shown = true;
                        this.showLadestromMessage();
                        data.seperate_abrechnung_emobil_strom_orig = 1;
                    } else if (data.seperate_abrechnung_emobil_strom === 1 && !found.seperate_abrechnung_emobil_strom) {
                        data.popup_shown = true;
                        this.showLadestromMessage();
                        data.seperate_abrechnung_emobil_strom_orig = 1;
                    }
                    if (+data.abrechnungsmodus === 2 && +found.abrechnungsmodus !== 2) {
                        // WKETOOL-69 385: Der Brennstoff-Rechner darf zukünftig nicht mehr automatisch Öffnen.
                        if (this.btnCalculator[btnKey]) {
                            this.btnCalculator[btnKey].props.onAction();
                        }
                    }
                }
                if (data.strom_dritte_name === 'Nein' || data.strom_dritte === 2) {
                    data.strom_dritte_orig = '';
                }
                if (data.seperate_abrechnung_emobil_strom_name === 'Nein' || data.seperate_abrechnung_emobil_strom === 2) {
                    data.seperate_abrechnung_emobil_strom_orig = '';
                }
            }
        }

        const formKey = data._formKey;
        this.dataTemp[entityName][formKey] = data;

        // Automatische Speicherung
        // Wir speichern nach einer kurzen Pause
        const autoSaveIntervall = getAutoSaveIntervall(this.props.data[IDs.ENT_KONFIGURATION]);
        let waitTime = (typeof timeout === 'number' && timeout >= 0) ? timeout : autoSaveIntervall;

        // Änderungen an Auswahl und Datum-Feldern
        if (field && field.typ && ['select', 'datepicker'].indexOf(field.typ) !== -1) {
            // speichern wir sofort.
            waitTime = 0;
        }

        const saveHandleId = window.setTimeout(() => {
            console.log('*** Automatische Speicherung beginnt ... ***');
            this.saveForms();
            this.saveHandleId = null;
        }, waitTime);
        clearTimeout(this.saveHandleId);
        this.saveHandleId = saveHandleId;
    }

    onEigenstromTypenChange(typenSel?: Array<any>) {
        const { data } = this.props;

        if (!typenSel) {
            typenSel = Array.isArray(data[IDs.ENT_ANLAGEN_EIGENSTROM])
                ? data[IDs.ENT_ANLAGEN_EIGENSTROM]
                    .filter((e: any) => e.standort_tid_orig === this.props.standortSelected.tid)
                    .map((e: any) => {
                        return {
                            tid: e.tid,
                            anlagen_eigenstrom_typ_tid: e.anlagen_eigenstrom_typ_tid_orig
                        };
                    })
                : [];
        }
        let typen = [];

        if (Array.isArray(typenSel) && typenSel.length > 0) {
            typen = Array.isArray(data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN]) ? data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] : [];
            typen = typen.filter((t: any) => typenSel.some((s: any) => s.anlagen_eigenstrom_typ_tid === t.tid));
        }
        // console.log(typen, typenSel);
        const eigenstrom_typen_s = typen.filter((d: any) => d.typ === 'S');
        const eigenwaerme_typen_w = typen.filter((d: any) => d.typ === 'W');
        const sortByName = (a: any, b: any) => {
            if (a.name > b.name) {
                return 1;
            }

            if (a.name < b.name) {
                return -1;
            }
            return 0;
        };
        eigenstrom_typen_s.sort(sortByName);
        eigenwaerme_typen_w.sort(sortByName);
        // console.log(typenSel, eigenstrom_typen_s, eigenwaerme_typen_w);

        if (this.state.eigenstrom_typen_s.map((t: any) => t.name).sort().join(',')
            !== eigenstrom_typen_s.map((t: any) => t.name).sort().join(',')) {
            const ent = IDs.ENT_ENERGIEDATEN_EIGENSTROM;
            // 29.09.2023 Eigenstrom darf mehrere Rechnungen für eine Anlage/Jahr haben.
            // Nach Änderung der Eigenstromtypen erneuert sich die Tapete.
            data[ent].forEach((r: any) => delete (r._formKey));
            const { extraForms } = this.state;
            delete (extraForms[ent]);
            this.setState({ eigenstrom_typen_s, extraForms }, () => this.forceRerenderForm(ent));
        }

        if (this.state.eigenwaerme_typen_w.map((t: any) => t.name).sort().join(',')
            !== eigenwaerme_typen_w.map((t: any) => t.name).sort().join(',')) {
            const ent = IDs.ENT_ENERGIEDATEN_EIGENWAERME;
            this.setState({ eigenwaerme_typen_w }, () => this.forceRerenderForm(ent));
        }
    }

    onValidate(data: any): void {
        const entity: string = data.entity || null;
        const fields: any = data.fields || {};
        const jahr: number = +data.jahr || null;
        const tid: number = +data.tid || null;
        const validation: any = this.state.validation || {};

        if (!jahr || !entity || !tid || !Object.keys(fields).length) {
            return;
        }

        if (!validation[jahr]) {
            validation[jahr] = { [entity]: {} };
        }

        if (!validation[jahr][entity]) {
            validation[jahr][entity] = {};
        }

        if (!validation[jahr][entity][tid]) {
            validation[jahr][entity][tid] = {};
        }
        validation[jahr][entity][tid] = fields;
        this.setState({ validation });
    }

    prepareKennziffernStructure(doUpdate?: boolean) {
        // Kennziffern-Definition holen und nach den Gewerken des Unternehmens filtern
        // Dazu die dynamischen Kennziffern (nur für dieses Unternehmen) holen
        const { kenn_dyn, kenn_def } = prepareStructureForKennziffern(this.props.data);
        // Wir erzeugen eine Struktur analog der statischen strukturen
        const struct = createStructureForKennziffern(kenn_def, kenn_dyn, IDs.ENT_KENNZIFFERN_GENERATED);
        // Die Struktur wird nun mit einem dynamischen Schlüssel ins Strucute-Tool gegeben
        const struct_tool = new StructureTool(IDs.MOD_ETOOL, this.props.data);
        // console.log('Struct Kennziffern', struct);

        // Auf Änderungen prüfen
        const check_key = struct.ATTS.map((att: any) => att.KEY).join(',');
        // console.log('prepareKennziffernStructure', this.lastCheckKey, check_key, doUpdate);
        const changed = doUpdate || !this.lastCheckKey || this.lastCheckKey !== check_key;
        this.lastCheckKey = check_key;
        struct_tool.addStructure(IDs.MOD_ETOOL, IDs.ENT_KENNZIFFERN_GENERATED, struct);

        if (changed) {
            // console.log('**** Struct Kennziffern Changed! ****');
            struct_tool.generateFormConfigFromStructure(IDs.ENT_KENNZIFFERN_GENERATED,
                { [IDs.ENT_KENNZIFFERN_GENERATED]: struct }, (formConfig: WFormConfig) => {
                    // console.log(formConfig);
                    this.setState({ presetFormConfig: { [IDs.ENT_KENNZIFFERN_GENERATED]: formConfig } }, () => {
                        this.forceRerenderForm(IDs.ENT_KENNZIFFERN_GENERATED);
                    });
                });
        } else {
            // console.log('**** Struct Kennziffern NOT Changed! ****');
        }
    }

    reloadBundle(entity: string) {
        const { entities } = this.state;

        if (Array.isArray(entities)) {
            const strom = entities.find((e: any) => e.entity === entity);

            if (strom) {
                this.dataService.loadDataForModul(entity, { tid: -1 }, { bundle: true }, IDs.MOD_ETOOL,
                    (result: any) => {
                        if (result) {
                            strom.bundle = result.bundle;
                        }
                        // console.log(entity,entities);
                        this.setState({ entities });
                    }
                );
            }
        }
    }

    reloadDataMonat(entity: string, callback?: () => void) {
        const { data } = this.props;
        this.dataService.loadData(entity, {}, { resolve: true }, (res: any) => {
            if (Array.isArray(res[entity])) {
                if (!data[entity]) {
                    data[entity] = [];
                }
                res[entity].forEach((r: any) => {
                    if (r.monat > 0 && r.parent_tid > 0) {
                        const idx = data[entity].findIndex((d: any) => d.tid === r.tid);
                        if (idx >= 0) {
                            data[entity][idx] = r;
                        } else {
                            data[entity].push(r);
                        }
                    }
                });
                // console.log(res[entity], data[entity]);
            }
            if (callback) {
                callback();
            }
        }, IDs.MOD_ETOOL);
    }

    reloadRerenderForm(entity: string, values: any, formKey: string, callback?: () => void) {
        const { data } = this.props;
        console.log('reloadRerenderForm', formKey, values.tid);
        this.dataService.loadData(entity, { tid: values.tid }, { resolve: true }, (res: any) => {
            if (Array.isArray(res[entity]) && res[entity].length > 0 && Array.isArray(data[entity])) {
                const row = res[entity][0];
                const idx = data[entity].findIndex((r: any) => r.tid === row.tid);
                if (formKey) {
                    row._formKey = formKey;
                }
                if (idx >= 0) {
                    data[entity][idx] = row;
                } else {
                    data[entity].push(row);
                }
                processKennziffernBerechnung(this.props.data);
                // 1. Rfg
                const didRerender = this.hasRfgChanged(entity, values);
                // 2. forceRerenderForm
                if (!didRerender) {
                    console.log('rerender', 'reloadRerenderForm', entity);
                    this.forceRerenderForm(entity);
                }
            }
            if (callback) {
                callback();
            }
            this.setFocusOnInput();
        }, IDs.MOD_ETOOL);
    }

    hasRfgChanged(entity: string, values: any) {
        const hasActivatedRfg = hasEntityActivatedRfg(entity, this.props.data);
        if (hasActivatedRfg && values) {
            const { data } = this.props;
            const fnd = data[entity].find((r: any) => r.tid === values.tid);
            if (fnd && fnd.rfg && values.rfg && fnd.rfg !== values.rfg) {
                // Entferne _formKey, um neue Sortierung zu erstellen.
                // Temp. Datensatz hat standort_tid statt standort_tid_orig
                data[entity].filter((r: any) => r.standort_tid_orig === (values.standort_tid_orig || values.standort_tid) && r.jahr === values.jahr)
                    .forEach((r: any) => delete (r._formKey));
                console.log('rerender', 'hasRfgChanged', entity);
                this.forceRerenderForm(entity);
                return true;
            }
        }
        return false;
    }

    render(): JSX.Element {
        const gewerk = getGewerk(this.props.data);

        if (!gewerk) {
            return (
                <div style={{ padding: 10 }}>
                    <br /><br />
                    Dieser Bereich steht aktuell noch nicht zur Verfügung,
                    bitte konfigurieren Sie zunächst ein Gewerk im Bereich Dateneingabe/Betriebliche Daten/Unternehmensdaten!
                </div>
            );
        }

        if (this.state.forceNoRenderOnce) {
            window.setTimeout(() => this.setState({ forceNoRenderOnce: false }), 500);
            return <WSpinner />;
        }

        const jahr_von = this.state.jahr_von;
        const jahr_bis = this.state.jahr_bis;
        const entities = this.state.entities;
        const dataYears: number[] = getDataYears(this.props.data, (entities || []).map((item: any) => item.entity), this.props.standortSelected.tid) || [];
        let verfuegbareJahre: string | JSX.Element = dataYears.length
            ? (dataYears.length > 1 && (dataYears[dataYears.length - 1] - dataYears[0] + 1) === dataYears.length)
                ? `${dataYears[0]} - ${dataYears[dataYears.length - 1]}`
                : dataYears.join(', ')
            : 'keine Daten';
        verfuegbareJahre = (
            <div style={{ fontSize: 11, height: '100%', display: 'flex', alignItems: 'center' }}>
                <strong>Verfügbare Jahre:</strong>&nbsp;{verfuegbareJahre}
            </div>
        );
        const showAllCheckBox = <div style={{ display: 'flex', marginLeft: -4, marginTop: 5 }}>
            <div key={'show_all_box'} style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <input
                    type='checkbox'
                    checked={this.state.showBereiche['showAll'] || false}
                    onChange={(evt: any) => {
                        const checked = evt.target.checked;
                        this.setState({ onFormRendering: true }, () => {
                            setTimeout(() => {
                                const showBereiche = this.state.showBereiche;
                                showBereiche['showAll'] = checked;
                                this.setState({ showBereiche }, () => {
                                    this.setState({ onFormRendering: false });
                                })
                            }, 0);
                        });
                    }}
                />&nbsp;
                <small><i>Alle Bereiche anzeigen</i></small>
            </div>
            {this.renderBtnDetailierteErfassung()}
        </div>;
        const importButton = <ImportButtonWrapper
            data={this.props.data}
            onRoutingChange={this.props.onRoutingChange}
            standortSelected={this.props.standortSelected}
            mode='small'
            onDone={(jahr: number) => {
                this.onEigenstromTypenChange();
                this.setState({
                    forceNoRenderOnce: true,
                    jahr_von: (jahr && jahr > 2009 && jahr < this.state.jahr_von)
                        ? jahr : this.state.jahr_von
                });
            }}
            doneText='Die Daten wurden importiert, bitte prüfen Sie die Werte, bevor Sie mit der Bearbeitung fortfahren.'
        />;

        const energiedatenAuswahl = getEnergiedatenAuswahl(this.props.data, this.props.standortSelected.tid, null, this.state.jahr_von, this.state.jahr_bis);

        return <>
            <div
                className={formStyle.formCompact}
                style={{
                    position: 'fixed', zIndex: 2, width: '100%', backgroundColor: '#eee', borderBottom: '2px solid #eee',
                    ...(this.props.style || {})
                }}
            >
                <div style={{ backgroundColor: 'white', right: 0, width: 20, height: 71, position: 'fixed' }} />
                <DatenauswertungJahrauswahl
                    // WKETOOL-93 - 447: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
                    jahrMin={this.state.jahr_min}
                    // jahrMin={2010}
                    jahrMax={this.state.jahr_max}
                    jahrFirst={this.state.jahr_von}
                    jahrLast={this.state.jahr_bis}
                    onFirstJahrChange={(jahr: number) => this.setJahrVon(+jahr)}
                    onLastJahrChange={(jahr: number) => this.setJahrBis(+jahr)}
                    externalHeaderElements={[/*verfuegbareJahre, importButton, */showAllCheckBox]}
                />
                {this.renderJahre({ titel: '', entity: 'jahre' }, jahr_von, jahr_bis, true)}
            </div>
            <div
                style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
                onClick={(event: any) => this.currentFormTarget = event.target}
                onChange={(event: any) => this.currentFormTarget = event.target}
                ref={(ref: any) => this.setLoaderStyle(ref)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 70, overflow: 'auto' }}>
                    {entities && entities
                        .filter((e: any) => !(this.selectableEnergiedatenEntities.indexOf(e.entity) !== -1 && energiedatenAuswahl.indexOf(e.entity) === -1))
                        .map((e: any, idx: number) =>
                            <React.Fragment key={`entity-${idx}`}>{this.renderEntity(e, jahr_von, jahr_bis)}</React.Fragment>
                        )}
                </div>
                {this.state.showDialog && this.renderDialog()}
                {this.state.dataForOptionalDialog && this.renderOptionalDialog()}
                {this.state.dataForOptionalDialog2 && this.renderOptionalDialog(1)}
                {!this.state.loadingDone && <WSpinner />}
                {this.state.onFormRendering && <WSpinner />}
                {this.state.jahrForEnergiedatenAuswahl > 0 && this.renderAuswahlDialog()}
            </div>
        </>;
    }

    renderBtnDetailierteErfassung(onWillChange?: () => void) {
        const { erfassungsmodus } = this.state;
        return <AuswahlErfassungsmodus
            data={this.props.data}
            erfassungsmodus={erfassungsmodus}
            onWillChange={onWillChange}
            onChange={(erfassungsmodus: string) => {
                this.setState({ erfassungsmodus, loadingDone: false }, () => {
                    const { showBereiche } = this.state;
                    this.setState({ showBereiche: {} }, () => this.setState({ showBereiche, loadingDone: true }, this.initValidierung));
                });
            }}
        />;
    }

    renderAusklappen(entity: any) {
        return (
            <div
                style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', padding: 5 }}
                onClick={() => {
                    const showBereiche = this.state.showBereiche;
                    showBereiche[entity.entity] = true;
                    // console.log(showBereiche);
                    this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
                }}
            >
                &#9654; &nbsp;<i>Dateneingabe öffnen</i>
            </div>
        );
    }

    renderAuswertungButton(route: any): JSX.Element {
        // const data: any = this.props.data || {};
        // const standort: any = this.props.standortSelected || {};
        // const standorte: any[] = getStandorte(data) || [];
        // const veranstaltung: any = standort
        //     ? (getVeranstaltungen(data) || []).find((item: any) => item.tid === standort.tid) : null;
        // let standortTabId: number = this.standortTids.indexOf(standort.tid);
        // standortTabId = standortTabId === -1 && veranstaltung ? standorte.length : standortTabId;
        // if (!route || standortTabId === -1) {
        //     return;
        // }
        // const path: any = { ...route, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: standortTabId + (standorte.length > 1 ? 2 : 1) };

        const data: any = this.props.data || {};
        const standort: any = this.props.standortSelected || {};
        if (!route || !standort.tid) {
            return;
        }

        // Tab-Routing
        let tabRouting: any = {};
        const istVeranstaltung = standort.standort_typ_tid_orig === 5 || standort.standort_typ_tid_orig === 6;
        if (!istVeranstaltung) {
            const standortRoutingFnd = findStandorteTabRouting(standort.tid, data, RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE, RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE, 2) || {};
            tabRouting = {
                path: standortRoutingFnd.path
            };
        } else {
            const basisRouting = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
            const basisTab = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
            const datenauswertungTabs = [
                { name: 'Energie-Cockpit' },
                { name: 'Gesamtunternehmen' },
                ...getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2)
            ];
            tabRouting = {
                path: {
                    ...basisRouting,
                    [basisTab]: datenauswertungTabs.length,
                    terminateOn: basisTab
                }
            };
        }
        tabRouting.path = { ...tabRouting.path, [RoutingIDs.TABS_DATENAUSWERTUNG]: route[RoutingIDs.TABS_DATENAUSWERTUNG] };

        return (
            <WActionButton
                label='Zur Auswertung'
                insideText='Zur Auswertung'
                tooltip='Zum Datenauswertungsbereich springen'
                key='auswertung'
                action='view'
                onAction={() => this.props.onRoutingChange({ ...tabRouting, ...(standort && { standort: standort.tid }) })}
            />
        );
    }

    renderBtnNeuerDS(entity: any) {
        const defaultElmt: JSX.Element = (
            <div style={{ textAlign: 'left', marginTop: 5, marginBottom: 5, marginLeft: this.props.scrollLeft || 0 }} />
        );
        const key = entity.entity;
        if ([IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_EIGENSTROM, IDs.ENT_ENERGIEDATEN_WAERME, IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE,
        IDs.ENT_ENERGIEDATEN_WASSER, IDs.ENT_KLIMAGASE, IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN, IDs.ENT_EIGENE_RAEUMLICHKEITEN,
        IDs.ENT_ANGEMIETETE_FAHRZEUGE].indexOf(key) !== -1) {
            let insideText = `Leere Zeile für ${entity.titel} einfügen`;
            switch (key) {
                case IDs.ENT_ENERGIEDATEN_STROM:
                    insideText = 'Neuen Strom-Datensatz/Zähler erfassen';
                    break;
                // 29.09.2023 Eigenstrom darf mehrere Rechnungen für eine Anlage/Jahr haben.
                case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
                    const { eigenstrom_typen_s } = this.state;
                    if (eigenstrom_typen_s.length === 0) {
                        // Es wurde keinen Eigenstromtyp ausgewählt.
                        return defaultElmt;
                    }
                    insideText = 'Neuen Eigenstrom-Datensatz erfassen';
                    break;
                case IDs.ENT_ENERGIEDATEN_WAERME:
                    insideText = 'Neuen Wärme-Datensatz erfassen';
                    break;
                case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
                    insideText = 'Neuen Kraftstoff-Datensatz erfassen';
                    break;
                case IDs.ENT_ENERGIEDATEN_WASSER:
                    insideText = 'Neuen Wasser/Abwasser-Datensatz erfassen';
                    break;
                case IDs.ENT_KLIMAGASE:
                    insideText = 'Weitere klimawirksame Gase hinzufügen';
                    break;
                case IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN:
                    insideText = 'Neue Räumlichkeit erfassen';
                    break;
                case IDs.ENT_EIGENE_RAEUMLICHKEITEN:
                    insideText = 'Neue eigene Räumlichkeit erfassen';
                    break;
                case IDs.ENT_ANGEMIETETE_FAHRZEUGE:
                    insideText = 'Neues Fahrzeug erfassen';
                    break;
            }
            return (
                <div style={{ textAlign: 'left', marginTop: 5, marginBottom: 5, marginLeft: this.props.scrollLeft || 0 }}>
                    <WActionButton
                        tooltip={insideText}
                        label={insideText}
                        action='add'
                        insideText={insideText}
                        key='btn_neuer_datensatz'
                        onAction={() => {
                            const { extraForms } = this.state;
                            extraForms[key] = extraForms[key] > 0 ? extraForms[key] : 0;
                            extraForms[key]++;
                            this.setState({ extraForms });
                        }}
                    />
                </div>
            );
        } else {
            return defaultElmt;
        }
    }

    renderDialog() {
        return (
            <div>
                <DialogWrapper2
                    width={-1}
                    onAfterClose={() => this.setState({ showDialog: undefined })}
                >
                    {this.state.showDialog === 'eigenstrom' &&
                        <div style={{ maxWidth: window.innerWidth - 60 }}>
                            <StandorteEigenstromTabs
                                routing={undefined}
                                onRoutingChange={() => { }}
                                standortSelected={this.props.standortSelected}
                                onTypenChange={this.onEigenstromTypenChange}
                                typeFilter='S'
                                data={this.props.data}
                            />
                        </div>}
                </DialogWrapper2>
            </div>
        );
    }

    renderEinklappen(entity: any) {
        return (
            <div
                style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', display: 'inline', padding: 5 }}
                onClick={() => {
                    const showBereiche = this.state.showBereiche;
                    delete (showBereiche[entity.entity]);
                    // console.log(showBereiche);
                    this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
                }}
            >
                &#9660; &nbsp;<i>Dateneingabe schließen</i>
            </div>
        );
    }

    renderEntity(entity: any, jahr_von: number, jahr_bis: number) {
        const { extraForms } = this.state;
        const key = entity.entity;

        const { data } = this.props;
        const forms: Array<JSX.Element> = [];
        let dataRows: Array<any> = Array.isArray(data[key]) ? data[key] : [];
        dataRows = dataRows.filter((r: any) => r.standort_tid_orig === this.props.standortSelected.tid && (!r.monat || r.monat === 0));

        // Struktur und Wertr für Gewerke-Kennziffern zusammenbauen
        if (key === IDs.ENT_KENNZIFFERN_GENERATED) {
            const werte = this.props.data[IDs.ENT_KENNZAHLEN_WERTE].filter((r: any) =>
                r.standort_tid_orig === this.props.standortSelected.tid);
            dataRows = transformWerteKennziffern(werte);
        }
        let rowCnt = 1;

        // WKETOOL-7 Datensatz-Sortierung in der Dateneingabe
        dataRows = sortKomplexDataRows(key, dataRows, data, jahr_von, jahr_bis);

        if (key === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
            // rowCnt = this.state.eigenstrom_typen_s.length;
            // 29.09.2023 Eigenstrom darf mehrere Rechnungen für eine Anlage/Jahr haben.
            const { eigenstrom_typen_s } = this.state;
            if (eigenstrom_typen_s.length > 0) {
                const esTypes = eigenstrom_typen_s.map((t: any) => t.tid);
                dataRows = dataRows.filter((r: any) =>
                    esTypes.indexOf(+r.anlagen_eigenstrom_typ_tid_orig) >= 0 || (r.anlagen_eigenstrom_typ_tid || 0) === 0
                );
                rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
            } else {
                // Es wurde kein Eigenstromtyp ausgewählt.
                rowCnt = 0;
            }
        } else if (key === IDs.ENT_ENERGIEDATEN_EIGENWAERME) {
            rowCnt = this.state.eigenwaerme_typen_w.length;
        } else if (key === IDs.ENT_ENERGIEDATEN_WAERME) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_ENERGIEDATEN_STROM) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_ENERGIEDATEN_WASSER) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_KLIMAGASE || key === IDs.ENT_KLIMAGASE_BENUTZER) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_EIGENE_RAEUMLICHKEITEN) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        } else if (key === IDs.ENT_ANGEMIETETE_FAHRZEUGE) {
            rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
        }

        const extraRowCnt = extraForms[key] > 0 ? extraForms[key] : 0;
        // console.log(key, dataRows, rowCnt, extraRowCnt);
        const hasBtnLeerZeile = [IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_EIGENSTROM, IDs.ENT_ENERGIEDATEN_WAERME,
        IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, IDs.ENT_ENERGIEDATEN_WASSER, IDs.ENT_KLIMAGASE, IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN,
        IDs.ENT_EIGENE_RAEUMLICHKEITEN, IDs.ENT_ANGEMIETETE_FAHRZEUGE].indexOf(key) !== -1;

        const stylrZZ: React.CSSProperties = {
            fontSize: 12, fontWeight: 'bold', padding: '3px 0 3px 5px', color: 'white', backgroundColor: '#616468',
            width: this.baseWidth * (jahr_bis - jahr_von + 2) + (jahr_bis - jahr_von + 1) + this.labelWidthExt
        };

        // Render Forms
        for (let i = 0; i < rowCnt; i++) {
            const rowName = this.renderRowName(entity, entity.titel, i + 1);
            // console.log('FORM', entity, dataRows);
            forms.push(
                <div className={formStyle.formCompact} style={{ marginBottom: 0 }} key={`form_0_${i}`}>
                    {rowCnt + extraRowCnt > 1 &&
                        <div style={stylrZZ}>
                            {hasBtnLeerZeile ? rowName : ''}
                            {/*hasBtnLeerZeile ? (entity.titel + ' ' + (i + 1)) : ''*/}
                        </div>}
                    <div className={formStyle.formCompact} style={{ display: 'flex', flexDirection: 'row' }}>
                        {this.renderFormRows(entity, dataRows, jahr_von, jahr_bis, i)}
                    </div>
                </div>
            );
        }
        // Render extra Forms
        for (let i = 0; i < extraRowCnt; i++) {
            const rowName = this.renderRowName(entity, entity.titel, rowCnt + i + 1);
            forms.push(
                <div style={{ marginBottom: 0 }} key={`form_1_${i}`}>
                    {rowCnt + extraRowCnt > 1 &&
                        <div style={stylrZZ}>
                            {hasBtnLeerZeile ? rowName : ''}
                            {/*hasBtnLeerZeile ? (entity.titel + ' ' + (rowCnt + i + 1)) : ''*/}
                        </div>
                    }
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {this.renderFormRows(entity, dataRows, jahr_von, jahr_bis, null, i)}
                    </div>
                </div>
            );
        }

        const showBereich = this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }} key={`ent_${key}`}>
                {this.renderJahre(entity, jahr_von, jahr_bis, false)}
                {showBereich && forms}
                {showBereich && this.renderBtnNeuerDS(entity)}
            </div>
        );
    }

    renderEntityTitel(entity: any): JSX.Element {
        entity = entity || {};
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const title: string = isOpenable ? 'Dateneingabe öffnen' : (isCloseable ? 'Dateneingabe schließen' : null);
        return (
            <div
                style={{ display: 'flex', alignItems: 'center', cursor: (isCloseable || isOpenable) ? 'pointer' : 'default' }}
                title={title}
                onClick={() => this.toggleShowBereich(entity)}
            >
                {(isCloseable || isOpenable) &&
                    <span style={{ fontSize: 11, fontWeight: 'normal', minWidth: 12, maxWidth: 12 }}>
                        {isOpenable ? <>&#9654;</> : <>&#9660;</>}
                    </span>
                }
                {entity.titel}
            </div>
        );
    }

    renderFormRows(entity: any, dataRows: any, jahr_von: number, jahr_bis: number, idx?: number, extraIdx?: number) {
        const forms: Array<JSX.Element> = [];
        let customFormConfig: any = {};
        let customOnSaveDone = undefined;
        let customOnDelDone = undefined;
        const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const alternatives_system: boolean = konfiguration
            .some((param: any) => param.alternatives_system_orig === 1);
        // Werte und Funktionen für Gewerke-Kennziffern zusammenbauen
        if (entity.entity === IDs.ENT_KENNZIFFERN_GENERATED) {
            customOnSaveDone = (entityName: string, values: any) => {
                saveDataKennziffern(values, this.props.data, this.dataService, this.triggerService);
                this.savedEntities[entityName] = true;
            };
            customOnDelDone = (entityName: string, row: any) => {
                delDataKennziffern(row, this.props.data, this.dataService);
                this.savedEntities[entityName] = true;
            };
        } else if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
            customFormConfig = {
                // anlagen_eigenstrom_typ_tid: { readonly: true },
                messsystem: { hidden: !alternatives_system }, kalibrierung: { hidden: !alternatives_system }
            };
        } else if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENWAERME) {
            customFormConfig = { anlagen_eigenstrom_typ_tid: { readonly: true } };
        } else if (entity.entity === IDs.ENT_ENERGIEDATEN_STROM) {
            const showElektrofahrzeuge = true; /* !!(this.props.data[IDs.ENT_KONFIGURATION] || [])
                .some((param: any) => param.daten_elektrofahrzeuge_orig === 1);*/

            customFormConfig = {
                gebaeude_tid: { show: false }, // Kein Gebäude mehr!
                ...(showElektrofahrzeuge ? {} : { seperate_abrechnung_emobil_strom: { hidden: true } })
            };
        }
        if (entity.entity === IDs.ENT_ENERGIEDATEN_STROM ||
            entity.entity === IDs.ENT_ENERGIEDATEN_WAERME ||
            entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE ||
            entity.entity === IDs.ENT_ENERGIEDATEN_WASSER) {
            // console.log('ALT_SYS: ', alternatives_system);
            if (!alternatives_system) {
                customFormConfig = {
                    ...customFormConfig,
                    messsystem: { hidden: true }, kalibrierung: { hidden: true }
                };
            }
        }

        const { eigenstrom_typen_s, eigenwaerme_typen_w } = this.state;
        const getEnergieTid = () => {
            // Beim Eigenstrom / Eigenwärme soll der Energietyp statt idx verwendet werden, um Konsistenz vom formKey zu sichern,
            // da sich rowCnt bei der Auswahl der Energien ändern kann.

            // 29.09.2023 Eigenstrom darf mehrere Rechnungen für eine Anlage/Jahr haben.
            // if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM && eigenstrom_typen_s[idx]) {
            //     return eigenstrom_typen_s[idx].tid;
            // }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENWAERME && eigenwaerme_typen_w[idx]) {
                return eigenwaerme_typen_w[idx].tid;
            }
            return null;
        };

        for (let j = jahr_von; j <= jahr_bis; j++) {
            const energiedatenAuswahl = getEnergiedatenAuswahl(this.props.data, this.props.standortSelected.tid, j);
            let formActive = true;
            if (this.selectableEnergiedatenEntities.indexOf(entity.entity) !== -1 && energiedatenAuswahl.indexOf(entity.entity) === -1) {
                formActive = false;
            }

            const isFirst = j === jahr_von;
            let rows = dataRows.filter((r: any) => r.jahr === j);

            const energieKey = getEnergieTid();
            const formKey = getFormKey(entity.entity, j, idx, extraIdx, energieKey, this.props.standortSelected.tid);

            if (entity.entity === IDs.ENT_ENERGIEDATEN_WASSER) {
                // console.log('Wasser ', j, formKey, rows);
            }

            let data: any = null;
            const fndByFormKey = rows.find((r: any) => r._formKey === formKey);

            // Passt der FormKey, gehört der DS dem Formula.
            if (fndByFormKey) {
                data = fndByFormKey;
            } else {
                // Nach dem 1. Round haben DS "_formKey"
                const len1 = rows.length;
                rows = rows.filter((r: any) => !r._formKey);
                const len2 = rows.length;
                // Wir berechnen Offset, da DS mit formKey schon eingesetzt wurden.
                const offs = len1 - len2;

                // 29.09.2023 Eigenstrom darf mehrere Rechnungen für eine Anlage/Jahr haben.
                // if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
                //     const styp = this.state.eigenstrom_typen_s[idx];
                //     if (styp) {
                //         data = rows.find((r: any) => r.anlagen_eigenstrom_typ_tid_orig === styp.tid);
                //         if (!data) {
                //             data = {
                //                 anlagen_eigenstrom_typ: styp.name,
                //                 anlagen_eigenstrom_typ_tid: styp.tid,
                //                 monat: 0
                //             };
                //         }
                //     }
                // }

                if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENWAERME) {
                    const wtyp = this.state.eigenwaerme_typen_w[idx];
                    if (wtyp) {
                        data = rows.find((r: any) => r.anlagen_eigenstrom_typ_tid_orig === wtyp.tid);
                        if (!data) {
                            data = {
                                anlagen_eigenstrom_typ: wtyp.name,
                                anlagen_eigenstrom_typ_tid: wtyp.tid,
                                monat: 0
                            };
                        }
                    }
                } else if (idx >= 0) {
                    data = rows[idx - offs];
                }

                // formkey in den ursprünglichen DS schreiben
                if (!data) {
                    data = { _formKey: formKey };
                    // Vorbelegung der neuen Daten
                    this.setDataPreset(entity.entity, data);
                } else {
                    data._formKey = formKey;
                }
            }

            // if (entity.entity === IDs.ENT_ANGEMIETETE_FAHRZEUGE
            //     || entity.entity === IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN
            //     || entity.entity === IDs.ENT_EIGENE_RAEUMLICHKEITEN
            // ) {
            //     customFormConfig = getCustomFormConfig(entity.entity, data, this.props.data);
            //     // console.log('FZG:', data, customFormConfig);
            // }
            // if (entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
            //     customFormConfig = { ...(customFormConfig || {}), ...(getCustomFormConfig(entity.entity, data, this.props.data) || {}) };
            // }

            customFormConfig = { ...(customFormConfig || {}), ...(getCustomFormConfig(entity.entity, data, this.props.data) || {}) };
            recordHiddenRows(`Komplex_${this.props.standortSelected.tid}`, formKey, customFormConfig, jahr_von, jahr_bis, j, entity.entity, formActive);

            const { doRenderForm } = this.state;
            const elemKey = formKey + (doRenderForm[entity.entity] === false || doRenderForm[formKey] === false ? '_tmp' : '');
            const form = <div
                onMouseEnter={(evt) => this.onMouseEnter(evt, formKey)}
                onMouseOver={(evt) => this.onMouseEnter(evt, formKey)}
                ref={(ref: any) => this.setFormStyle(ref, isFirst)}
            >
                <DateneingabeEnergiedatenKomplexForm
                    showMode={this.enableFormShowMode && this.state.activeFormKey !== formKey}
                    WFormId={formKey}
                    key={elemKey}
                    layout='sidebysideComplex'
                    formKey={formKey}
                    entity={entity}
                    isFirst={isFirst}
                    hideAllFields={!formActive}
                    jahr={j}
                    presetFormConfig={this.state.presetFormConfig[entity.entity]}
                    customFormConfig={customFormConfig}
                    dataItem={data}
                    data={this.props.data}
                    standort={this.props.standortSelected}
                    onChange={this.onChange}
                    getExtraElement={this.getFormRechnerBtn}
                    getExtraElement2={this.getFormRechnerBtn}
                    getFunktionBtn={this.getFormFunktionBtn}
                    currentYear={this.state.currentYear}
                    posFieldsHelpBeginning={true}
                    onCurrentYearChange={(year: number) => this.setState({ currentYear: year })}
                    customOnSaveDone={customOnSaveDone}
                    customOnDelDone={customOnDelDone}
                    reloadBundle={() => this.reloadBundle(entity.entity)}
                    reloadDataMonat={this.reloadDataMonat}
                    customCssStyle={{
                        // Layout-Problem (calc() Fehler) nur mit FF 78 ESR, hier eine temporäre Lösung
                        ...(entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE ?
                            { formField: { verbrauch: { input: { width: 144 } } } } : {}),
                        // ...(entity.entity === IDs.ENT_KLIMAGASE ?
                        //     {
                        //         formFieldSelect: { art_tid: { selectStyle: { height: 35 } } },
                        //         formField: { art_tid: { height: 45 } }
                        //     } : {})
                    }}
                    onValidate={this.onValidate}
                />
            </div>;
            forms.push(form);
        }
        return forms;
    }

    setDataPreset(entity: string, data: any) {
        switch (entity) {
            case IDs.ENT_ENERGIEDATEN_STROM:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
            case IDs.ENT_ENERGIEDATEN_WASSER:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
            case IDs.ENT_ENERGIEDATEN_WAERME:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
        }
    }

    renderJahre(entity: any, jahr_von: number, jahr_bis: number, scroll: boolean) {
        // console.log('Render jahre', jahr_von, jahr_bis);
        const isFirst: boolean = !(this.state.entities || []).findIndex((item: any) => item.entity === entity.entity);
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const isEMIEJMAED = gibtEMIEJMAED(this.props.data[entity.entity] || [], jahr_von, jahr_bis, this.props.standortSelected.tid);
        const title: string = isOpenable ? 'Dateneingabe öffnen' : (isCloseable ? 'Dateneingabe schließen' : null);
        const st: any = {
            display: 'flex', alignItems: 'center', color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)',
            fontSize: 18, boxSizing: 'border-box', padding: '3px 5px', fontWeight: 'bold', marginRight: 1, width: this.baseWidth,
            minWidth: this.baseWidth
        };
        // if (entity.entity === 'jahre') {
        //     st.textAlign = 'center';
        // }
        const st_button: any = {
            fontSize: 18, textAlign: 'left', boxSizing: 'border-box', paddingLeft: 10, fontWeight: 'bold', marginRight: 1,
            width: this.baseWidth, minWidth: this.baseWidth
        };
        const jahre: Array<JSX.Element> = [];
        jahre.push(
            <div
                style={{
                    ...st, width: this.baseWidth + this.labelWidthExt, minWidth: this.baseWidth + this.labelWidthExt,
                    boxShadow: 'white 1px 0', ...(!scroll && { marginLeft: this.props.scrollLeft || 0, justifyContent: 'space-between' }),
                    zIndex: 1
                }}
                key={`jahr_${entity.entity}_head`}
            >
                {this.renderEntityTitel(entity)}
                {showBereich && entity.headerElement && <div style={{ textAlign: 'right' }}>{entity.headerElement}</div>}
                {showBereich && entity.entity !== 'jahre' && isEMIEJMAED && <CustomDatensatzRfg
                    data={this.props.data}
                    entity={entity.entity}
                    onChange={() => {
                        // Entferne _formKey, um neue Sortierung zu erstellen.
                        this.props.data[entity.entity].forEach((r: any) => delete (r._formKey));
                        // Entferne extra Zeile
                        const extraForms = this.state.extraForms;
                        delete (extraForms[entity.entity]);
                        this.setState({ extraForms }, () => {
                            console.log('rerender', 'CustomDatensatzRfg', entity.entity);
                            this.forceRerenderForm(entity.entity);
                        });
                    }}
                />}
            </div>
        );

        const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const enableCO2: boolean = isEnableCO2(konfiguration);
        const enableSachanlagen: boolean = isEnableSachanlagen(konfiguration);
        const enableGHG: boolean = isEnableGHG(konfiguration);

        for (let j = jahr_von; j <= jahr_bis; j++) {
            const isCurrentYear = this.state.currentYear && this.state.currentYear === j;
            // const backgroundColor: string = isCurrentYear ? '#6692c3' : '#bccae3';
            const backgroundColor: string = isCurrentYear ? 'var(--color-section-table-header-highlight)' : 'var(--color-section-main)';
            const color: string = isCurrentYear ? 'var(--color-button-text)' : 'var(--color-button-text)';
            jahre.push(
                <div
                    style={{
                        ...st, color, backgroundColor, ...((j === jahr_von) && { marginLeft: -this.props.scrollLeft || 0 }),
                        cursor: (isCloseable || isOpenable) ? 'pointer' : 'default'
                    }}
                    key={`jahr_${entity.entity}_${j}`}
                    title={title}
                    onClick={() => this.toggleShowBereich(entity)}
                >
                    {/*entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll && j === jahr_von && this.renderEinklappen(entity)*/}
                    {/*entity.entity !== 'jahre' && !showBereich && j === jahr_von && this.renderAusklappen(entity)*/}
                    {entity.entity === 'jahre' && j}
                    {entity.entity === 'jahre'/* && enableCO2*/ && enableSachanlagen && enableGHG &&
                        <button
                            style={{ cursor: 'pointer', border: '1px solid', width: 100, marginLeft: 5 }}
                            onClick={() => this.setState({ jahrForEnergiedatenAuswahl: j })}
                        >
                            Auswahl
                        </button>
                    }
                    {entity.entity === 'jahre' && j &&
                        <ValidierungHinweise
                            data={this.props.data}
                            entities={this.state.entities}
                            id={j}
                            layout2
                            showPriorityColors
                            style={{ margin: 'auto 9px auto auto' }}
                            validation={this.state.validation}
                        />
                    }
                </div>
            );
        }
        // Button zur Auswertung
        jahre.push(
            <div style={st_button} key={`jahr_${entity.entity}_ausw`}>
                {/*(typeof entity.tabAuswertungId === 'number') && this.renderAuswertungButton(entity.tabAuswertungId)*/}
                {entity.route && this.state.validData[entity.entity] && this.renderAuswertungButton(entity.route)}
            </div>
        );
        return (
            <div
                key={`jahre_${entity.entity}`}
                style={{
                    display: 'flex', flexDirection: 'row',
                    ...(entity.entity === 'jahre' ? { overflowX: 'hidden' } : {}),
                    ...(!isFirst && { marginTop: 2 })
                    /*, marginTop: 2, marginLeft: scroll ? (-1 * this.props.scrollLeft) : 0*/
                }}
            >
                {jahre}
            </div>
        );
    }

    renderAuswahlDialog() {
        return (
            <DialogWrapper2
                width={-1}
                onAfterClose={() => this.setState({ jahrForEnergiedatenAuswahl: null }, this.initValidierung)}
            >
                <div style={{ padding: 10, display: 'flex', flex: 1 }}>
                    <DateneingabeSachanlagenAuswahl
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        jahrFix={this.state.jahrForEnergiedatenAuswahl}
                        onClose={() => this.setState({ jahrForEnergiedatenAuswahl: null }, this.initValidierung)}
                    />
                </div>
            </DialogWrapper2>
        );
    }

    renderOptionalDialog(id: number = 0) {
        const key = id === 1 ? 'dataForOptionalDialog2' : 'dataForOptionalDialog';
        const dataForOptionalDialog = this.state[key];
        const ent = dataForOptionalDialog.entity.entity;

        let title: string;
        if (dataForOptionalDialog) {
            title = `${dataForOptionalDialog.jahr}\u00A0\u00A0\u00A0\u00A0\u00A0${dataForOptionalDialog.standortSelected.name}`;
            if (ent === IDs.ENT_ENERGIEDATEN_STROM) {
                const zaehlerTid = (dataForOptionalDialog.values || {}).zaehler_tid_orig;
                const zaehlernummer = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_STROM}_bundle`] || {}).zaehler_tid || [])
                    .find((item: any) => item.tid === zaehlerTid) || {}).zaehlernummer || '';
                title += `\u00A0\u00A0\u00A0\u00A0\u00A0${zaehlernummer}`;
            } else if (ent === IDs.ENT_ENERGIEDATEN_WAERME) {
                const energietraegerTid = (dataForOptionalDialog.values || {}).energietraeger_tid_orig;
                const energietraeger = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_WAERME}_bundle`] || {}).energietraeger_tid || [])
                    .find((item: any) => item.tid === energietraegerTid) || {}).name || '';
                title += `\u00A0\u00A0\u00A0\u00A0\u00A0${energietraeger}`;
            }
        }

        return (
            <div style={{ width: 780, paddingLeft: 20 }}>
                <DialogWrapper2
                    title={title}
                    width={-1}
                    onAfterClose={() => this.setState<never>({ [key]: undefined })}
                >
                    {ent === IDs.ENT_ENERGIEDATEN_STROM && id === 0 &&
                        <DialogStromVerbrauch
                            data={this.props.data}
                            standortSelected={dataForOptionalDialog.standortSelected}
                            jahr={dataForOptionalDialog.jahr}
                            values={dataForOptionalDialog.values}
                            onChange={(entityName: string, formValues: any) => {
                                this.reloadDataMonat(entityName);
                                this.onChange(entityName, formValues, null, 0);
                            }}
                            onClose={() => this.setState<never>({ [key]: undefined })}
                        />
                    }
                    {ent === IDs.ENT_ENERGIEDATEN_WAERME && id === 0 &&
                        <DialogWaermeVerbrauch
                            data={this.props.data}
                            standortSelected={dataForOptionalDialog.standortSelected}
                            jahr={dataForOptionalDialog.jahr}
                            values={dataForOptionalDialog.values}
                            onChange={(entityName: string, formValues: any) => {
                                this.reloadDataMonat(entityName);
                                this.onChange(entityName, formValues, null, 0);
                            }}
                            onClose={() => this.setState<never>({ [key]: undefined })}
                        />
                    }
                    {ent === IDs.ENT_ENERGIEDATEN_WAERME && id === 1 &&
                        <DialogOelBerechnung
                            data={this.props.data}
                            standortSelected={dataForOptionalDialog.standortSelected}
                            jahr={dataForOptionalDialog.jahr}
                            values={dataForOptionalDialog.values}
                            einheit={dataForOptionalDialog.einheit_tid_orig}
                            energietraeger={dataForOptionalDialog.energietraeger_tid_orig}
                            onClose={() => this.setState<never>({ [key]: undefined })}
                            onTake={(verbrauch: number, kosten: number) => {
                                // dataForOptionalDialog.setValues({ verbrauch, kosten });
                                const valuesNew = { ...dataForOptionalDialog.values, ...{ verbrauch, kosten } };
                                this.onChange(ent, valuesNew, null, 0);
                                this.setState<never>({ [key]: undefined });
                            }}
                        />
                    }
                </DialogWrapper2>
            </div>
        );
    }

    renderRowName(entity: any, name: string, position: number): JSX.Element | string {
        // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
        const enableRfg = true;
        return enableRfg
            ? <CustomRowName
                data={this.props.data}
                entity={entity.entity}
                id={`${entity}_${name}_${position}`}
                key={`${entity}_${name}_${position}`}
                name={name}
                position={position}
            />
            : `${name || ''} ${position || ''}`;
    }

    setFocusOnInput() {
        // Den Eingabefeld wieder fokussieren.
        if (this.currentFormTarget) {
            const tag = this.currentFormTarget.tagName;
            const id = this.currentFormTarget.id;
            let ele;
            if (tag === 'INPUT') {
                ele = document.getElementById(id) as HTMLInputElement;
            } else if (tag === 'TEXTAREA') {
                ele = document.getElementById(id) as HTMLTextAreaElement;
            }
            // console.log(id, tag, ele);
            if (ele) {
                ele.focus();
                const val = ele.value;
                ele.value = '';
                ele.value = val;
            }
        }
    }

    saveForms() {
        const tmp = this.dataTemp;
        let cnt = 0;
        Object.keys(tmp).forEach((ent: string) => {
            this.savedEntities[ent] = true;

            Object.keys(tmp[ent]).forEach((formKey: string) => {
                // console.log('saving ...', formKey);
                const values = tmp[ent][formKey];

                const cntNReload = () => {
                    // console.log('done ...', formKey);
                    cnt--;
                    if (cnt === 0) {
                        const validData: any = this.getValidDataEntitiesMap();
                        console.log('saveForms done all');
                        this.setState({ loadingDone: true, validData });
                    }
                };

                if (ent === IDs.ENT_KENNZIFFERN_GENERATED) {
                    cnt++;
                    saveDataKennziffern(values, this.props.data, this.dataService, this.triggerService, () => {
                        this.forceRerenderForm(ent);
                        cntNReload();
                    });
                } else {
                    cnt++;
                    this.dataService.saveData(ent, values, undefined, false,
                        (success: boolean, saveTid: number) => {
                            // console.log(ent, values, success, saveTid);
                            if (success) {
                                if ((!values.tid || values.tid === 0) && saveTid > 0) {
                                    values.tid = saveTid;
                                }
                                this.reloadRerenderForm(ent, values, formKey, cntNReload);
                            } else {
                                cntNReload();
                            }
                        },
                        IDs.MOD_ETOOL
                    );
                }

                delete (tmp[ent][formKey]);
            });
        });

        if (cnt > 0) {
            this.setState({ loadingDone: false });
        }
    }

    setFormStyle(ref: any, isFirstYear: boolean): void {
        if (ref === null || !isFirstYear) {
            return;
        }
        const labels: NodeListOf<HTMLElement> = ref.querySelectorAll('div[class^="label"]');
        for (let index = 0, length: number = labels.length; index < length; ++index) {
            const label: HTMLElement = labels[index];
            label.style.setProperty('margin-left', `${this.props.scrollLeft || 0}px`);
            label.style.setProperty('z-index', '1');
            label.style.setProperty('box-shadow', 'white 1px 0');
        }
        const inputs: NodeListOf<HTMLElement> = ref.querySelectorAll('div[class^="input"]');
        for (let index = 0, length: number = inputs.length; index < length; ++index) {
            const input: HTMLElement = inputs[index];
            input.style.setProperty('margin-left', `-${this.props.scrollLeft || 0}px`);
        }
    }

    setLoaderStyle(ref: any): void {
        if (ref === null) {
            return;
        }
        const div: HTMLElement = ref.querySelector('div[class^="loader"]')
        if (div && div.style) {
            div.style.setProperty('z-index', '3');
            const span: HTMLElement = div.querySelector('div > span:nth-child(1)');
            if (span && span.style) {
                span.style.setProperty('background-color', 'lightgray');
            }
        }
    }

    setJahrBis(jahr: number) {
        let jahr_von = this.state.jahr_von;

        if (jahr_von < jahr - this.yearRange + 1) {
            jahr_von++;
        }
        this.setState({ jahr_bis: jahr, jahr_von }, this.saveJahre);
    }

    saveJahre() {
        const { konfig, jahr_von, jahr_bis } = this.state;
        if (konfig?.tid > 0) {
            const data = {
                tid: konfig.tid,
                dateneingabe_form_jahr_von: jahr_von,
                dateneingabe_form_jahr_bis: jahr_bis
            };
            this.dataService.saveData(IDs.ENT_KONFIGURATION, data, undefined, false,
                (success: boolean, saveTid: number) => {
                    this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
                }, IDs.MOD_ETOOL);
        }
    }

    setJahrVon(jahr: number) {
        let jahr_bis = this.state.jahr_bis;

        if (jahr_bis > jahr + this.yearRange - 1) {
            jahr_bis--;
        }
        console.log('Jahr', jahr, jahr_bis);
        this.setState({ jahr_von: jahr, jahr_bis }, this.saveJahre);
    }

    showKraftstoffeEnergietraegerLadestromMessage() {
        const msg = 'Bitte geben Sie hier nur dann Verbrauchsdaten ein, wenn der Strom für Ihr/e E-Fahrzeug/e separat vom restlichen Strom abgerechnet wird und somit nicht bereits zuvor unter "Strom" erfasst wurde.';
        alert(msg);
    }

    showLadestromMessage() {
        const msg = 'Der Stromverbrauch für den Betrieb von Wärmepumpen ist im Bereich "Wärme" zu erfassen - allerdings nur dann, wenn eine Abgrenzung vom restlichen Strom problemlos möglich ist. Das ist i.d.R. dann der Fall, wenn Sie einen Wärmepumpen-Tarif und somit einen separaten Stromzähler für Wärmepumpenstrom haben.' +
            '\n\n' +
            'Ladestrom für E-Fahrzeuge ist nach Möglichkeit im Bereich "Kraftstoffe" zu erfassen. Dies ist allerdings i.d.R. nur dann möglich, wenn betriebsintern über Ladesäulen / Wallboxen etc. geladen wird und die entsprechenden Verbrauchswerte dieser Geräte separat erfasst bzw. ausgelesen werden können. Hilfsweise können Sie den genutzten Ladestrom über den Durchschnittsverbrauch und die Jahresfahrleistung abschätzen.' +
            '\n\n' +
            'ACHTUNG: Wenn Sie Stromverbräuche für Wärmepumpen im Bereich "Wärme" und/oder E-Autos im Bereich "Kraftstoffe" eintragen, achten Sie bitte unbedingt darauf, hier in der regulären Stromdatenerfassung, den Wert im Erfassungsfeld "Bezugsmenge vom Versorgungsunternehmen [kWh]" entsprechend zu verringern (da sich ansonsten ein überhöhter Gesamtstromverbrauch ergibt)!' +
            '\n\n' +
            'Lassen sich der Wärmepumpen- bzw. E-Fahrzeug-Ladestrom nicht separat ermitteln, sollte dies bei der Beurteilung der eigenen Datenauswertung berücksichtigt werden: Der Stromverbrauch ist dann unverhältnismäßig hoch und der Wärme- bzw. Kraftstoffverbrauch unverhältnismäßig gering.';
        alert(msg);
    }

    showStromDritteMessage() {
        let msg: string;
        if (this.props.data.MODUL_SELECTED === 'steuer') {
            msg = 'Sofern ein Teil des von Ihrem Energieversorgungsunternehmens gelieferten Stroms an Dritte weitergegeben wird (Mieter:innen, öffentl. Ladestationen etc.), tragen Sie bitte hier NUR den Anteil in kWh ein, der tatsächlich im eigenen Betrieb verbraucht wird.'
                + '\n\n'
                + 'Tragen Sie bitte die weitergeleitete Strommenge (also den Anteil Ihrer Gesamtstromrechnung, der NICHT für eigene Betriebszwecke verbraucht wurde) in das Feld „Weitergeleitete Strommenge“ ein.';
        } else {
            msg = 'Sofern ein Teil des von Ihrem Energieversorgungsunternehmens gelieferten Stroms an Dritte weitergegeben wird (Mieter:innen, öffentl. Ladestationen etc.), bitte berücksichtigen, dass hier nur der Anteil in kWh einzutragen ist, der tatsächlich im Betrieb verbraucht wird.';
        }
        alert(msg);
    }

    showWaermeDritteMessage() {
        let msg: string;
        if (this.props.data.MODUL_SELECTED === 'steuer') {
            msg = 'Wenn Wärme an Dritte abgegeben wird, bitte berücksichtigen, dass hier nur der Anteil in kWh anzugeben ist, der im Betrieb verbleibt.'
                + '\n\n'
                + 'Tragen Sie bitte die weitergeleitete Wärmemenge (also den Anteil, der NICHT für eigene Betriebszwecke verbraucht wurde) in das Feld „Weitergeleitete Wärmemenge“ ein.';
        } else {
            msg = 'Wenn Wärme an Dritte abgegeben wird, bitte berücksichtigen, dass hier nur der Anteil in kWh anzugeben ist, der im Betrieb verbleibt.';
        }
        alert(msg);
    }

    showWaermeEnergietraegerEinheitMessage() {
        const msg = 'Bitte wählen Sie zunächst Energieträger und Einheit aus. Erst im Anschluss können Sie den Abrechnungsmodus Monatsrechnungen wählen.';
        alert(msg);
    }

    showWaermeEnergietraegerStromMessage() {
        const msg = 'Bitte geben Sie hier nur dann Verbrauchsdaten ein, wenn der Strom für Ihre Heizung separat vom restlichen Strom abgerechnet wird und somit nicht bereits zuvor unter "Strom" erfasst wurde (z.B. wenn bei Wärmepumpennutzung ein Wärmepumpentarif vereinbart wurde)';
        alert(msg);
    }

    onMouseEnter(evt: any, formKey: string) {
        if (this.enableFormShowMode) {
            const hasDatePicker = document.querySelector(`.${formStyle.formCompact} .react-datepicker`) !== null;
            if (
                // Linke Mousetaste wird beim Text-markieren gedrückt.
                evt.buttons === 1
                // Ignoriere, wenn onMouseLeave durch den Systemeingabevorschlag getriggert ist.
                // Dabei evt.nativeEvent.relatedTarget = null
                || !evt.nativeEvent.relatedTarget
                // Das aktuelle Formular enthält einen aktiven React-datepicker.
                || hasDatePicker
            ) {
                return;
            }
            // WKETOOL-26: 1515 Problem beim Datepicker (nur mit Firefox)
            // Ignoriere, wenn onMouseLeave durch den DatePicker getriggert ist.
            if (evt.nativeEvent.relatedTarget && evt.nativeEvent.relatedTarget.classList) {
                const classList = Array.from(evt.nativeEvent.relatedTarget.classList);
                if (classList.find((cls: string) => cls.startsWith('react-datepicker'))) {
                    return;
                }
            }
            if (this.state.activeFormKey !== formKey) {
                this.setState({ activeFormKey: formKey });
            }
        }
    }

    toggleShowBereich(entity: any): void {
        entity = entity || {};
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const showBereiche: any = this.state.showBereiche || {};
        if (isOpenable) {
            showBereiche[entity.entity] = true;
        } else if (isCloseable) {
            delete (showBereiche[entity.entity]);
        } else {
            return;
        }
        this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
    }
}
